<template>

<!-- DIALOG PARA APONTAR O LOTE -->
  <v-card v-if="identificar">
    <v-card-title
      class="header headline green white--text justify-space-between"
    >
      <div class="header">Identificar Lote</div>
      <v-icon large class="mx-1 my-1 icone white--text"> mdi-magnify </v-icon>
    </v-card-title>
    <div class="container">
      <v-form ref="formIdentificar" lazy-validation>
        <div class="d-flex justify-center contaainer">
            <v-text-field ref="secador"
              outlined label="Secador" class="textfield n-center"
              background-color="white" type="number" readonly
              :dense="!$_isMobile"
              v-model="this.$props.idsecador"
              @keyup.enter="$refs.secador.blur(); $refs.lote.$children[0].focus();">
            </v-text-field>
              <!-- <p>Selecione um lote para criar um novo apontamento.</p> -->
            <card-auto-complete ref="lote"
              label="Lote P.A."
              class="textfield n-center"
              :dados="lotesdaop" 
              :dense="!$_isMobile"
              v-model="qrcode.idaberturalote"
              itemLabel="ablnrocontrole"  
              item-value="ablidaberturalote"
              :return-object="false"
              hide-details
              icon="mdi-qrcode-scan"
              :action="$_onClickQR"
              @keyup.enter="$refs.lote.$children[0].blur(); $refs.umidade.focus()"
            />
            <v-card class="descricaoextra" v-if="lotecompleto?.abldescricao">
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.abldescricao}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.ablgranulometria}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.vardescricao}}</b>
              <v-divider v-if="lotecompleto?.apppeso"></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.apppeso}}</b>
            </v-card>
            <div class="justify-center">
              <v-btn color="primary" class="salvar" @click="$_enviarLote">Salvar</v-btn>
            </div>
        </div>
      </v-form>
    </div>
  </v-card>
<!-- ////////////////////// -->


<!-- DIALOG P/ INICIAR/FINALIZAR O ABASTECIMENTO -->
  <v-card v-else-if="abastecer">
    <v-card-title
      class="header headline green white--text justify-space-between">
      <div class="header">
      <v-icon 
      @click="$emit('voltar')" class="icone white--text">mdi-arrow-left</v-icon>
        Abastecer</div>
      <v-icon large class="mx-1 my-1 icone white--text"> mdi-grain </v-icon>
    </v-card-title>
    <div class="container">
        <v-form ref="formAbastecimento" lazy-validation>
            <div class="d-flex justify-center contaainer">
              <v-text-field ref="secador"
              outlined label="Secador" class="textfield n-center"
              background-color="white" type="number" readonly
              :dense="!$_isMobile"
              v-model="this.$props.idsecador"
              @keyup.enter="$refs.secador.blur();">
            </v-text-field>
              <!-- <p>Selecione um lote para criar um novo apontamento.</p> -->
            <card-auto-complete ref="lote"
              label="Lote P.A."
              class="textfield n-center"
              :dados="lotesdaop" 
              :dense="!$_isMobile"
              v-model="qrcode.idaberturalote"
              itemLabel="ablnrocontrole"  
              item-value="ablidaberturalote"
              :return-object="false"
              hide-details
              :menu-props="{maxHeight: 200, autoOverflow: true}"
              icon="mdi-qrcode-scan"
              :action="$_onClickQR"
              :rules="rules.abslote"
              
            />
            <v-card class="descricaoextra" v-if="lotecompleto?.abldescricao">
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.abldescricao}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.ablgranulometria}}</b>
              <v-divider></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.vardescricao}}</b>
              <v-divider v-if="lotecompleto?.apppeso"></v-divider>
              <b class="centerextra" style="font-weight: 600;">{{lotecompleto?.apppeso}}</b>
            </v-card>
              
              <core-date-time-picker-field
                hide-details
                form
                :dense="false"
                v-model="abastecimento.inicio"
                :label="['Data inicio', 'Hora']"
                :rules="rules.absinicio"
              />
              <core-date-time-picker-field
                hide-details
                form
                :dense="false"
                :clearable="true"
                :sem-valor="semvalor"
                :horaAuto="true"
                ref="datatermino"
                @limpatermino="$_terminoResetaValor"
                v-model="abastecimento.termino"
                :label="['Data termino', 'Hora']"
                :rules="rules.abstermino"
              />
              <v-btn color="primary" class="salvar" @click="$_enviarAbastecimento">Salvar</v-btn>
            </div>
              <!-- <v-btn @click="$_cancelar">Cancelar</v-btn> -->
        </v-form>
    </div>
  </v-card>
<!-- ////////////////////// -->

<!-- DIALOG DA OPERAÇÃO -->
  <v-card v-else-if="op">
    <v-card-title
      class="header headline green white--text justify-space-between">

      <div class="header">
      <v-icon 
      @click="$emit('voltar')"
      class="icone white--text">mdi-arrow-left</v-icon>
        Operação</div>
      <v-icon large class="mx-1 my-1 icone white--text"> mdi-button-pointer</v-icon>
    </v-card-title>
    <div class="container">
        <v-form ref="formOperacao" lazy-validation>
          <div class="d-flex justify-center contaainer">
              <v-select
                label="Operação"
                :rules="rules.opetipo"
                class="n-center"
                :items="tipooperacao"
                icon="mdi-chevron-down"
                v-model="operacao.operacao"
                outlined
                :menu-props="{ bottom: true, offsetY: true }"
              >
              </v-select>
              <v-currency-field ref="peso"
                :dense="!$_isMobile"
                maxlength=10
                
                :decimalLength="3"
                outlined label="Peso Inicial (Kg)" class="textfield n-center"
                background-color="white"
                v-model="operacao.peso"
                >
              </v-currency-field>
              <v-text-field ref="umidade"
                :dense="!$_isMobile"
                outlined label="Umidade Inicial (%)" class="textfield n-center" type="number"
                background-color="white" 
                :rules="rules.opeumidade"
                v-model="operacao.umidade"
                @keyup.enter="$refs.umidade.blur();">
              </v-text-field>
              <div class="d-flex">
                <v-text-field ref="umidadear"
                :dense="!$_isMobile"
                outlined label="Umid. Ar (%)" class="textfield n-center" type="number"
                
                background-color="white"
                v-model="operacao.umidadear"
                @keyup.enter="$refs.umidadear.blur();">
                </v-text-field>
                <v-text-field ref="temperaturaar"
                :dense="!$_isMobile"
                outlined label="Temp. Ar (%)" class="textfield n-center" type="number"
                
                background-color="white"
                v-model="operacao.temperaturaar"
                @keyup.enter="$refs.temperaturaar.blur();">
                </v-text-field>
              </div>
              <core-date-time-picker-field
                hide-details
                form
                :dense="false"
                v-model="operacao.inicio"
                :label="['Data inicio', 'Hora']"
                :rules="rules.opeinicio"
              />
              <v-btn color="primary" class="salvar" @click="$_enviarOperacao">Iniciar</v-btn>
          </div>
        </v-form>
      <!-- <v-text-field></v-text-field> -->
      <br/>
    </div>
  </v-card>
<!-- ////////////////////// -->


  <v-card v-else-if="loa">
    <v-card-title
      class="header headline green white--text justify-space-between">
      <div class="header">
      <v-icon @click="$emit('voltar')" class="icone white--text">mdi-arrow-left</v-icon>
      Armazenamento</div>
      <v-icon large class="mx-1 my-1 icone white--text"> mdi-barn </v-icon>
    </v-card-title>
    <div class="container">
        <v-form ref="formArmazenamento" lazy-validation>
            <div class="d-flex justify-center contaainer">
              <btn-auto-complete
                label="Local Armazenamento"
                class="n-center"
                :dados="localarmazenamento"
                icon="mdi-chevron-down"
                v-model="formArmazenamento.local"
                :returnObject="true"
                item-label="loadescricao"
                :rules="rules.armlocal"
                item-value="loacodigoarmazem"
              />

              <core-date-time-picker-field
                hide-details
                form
                :dense="false"
                v-model="formArmazenamento.data"
                :label="['Data Fin./Armazen.', 'Hora']"
                :rules="rules.armdata"
              />

              <v-btn color="primary" class="salvar" @click="$_enviarArmazenamento">Salvar</v-btn>
            </div>
              <!-- <v-btn @click="$_cancelar">Cancelar</v-btn> -->
        </v-form>
    </div>
  </v-card>
</template>

<script>

// import errorHandler from '@/utils/error-handler';

import { ROUTE_PRODUCAO_CADASTRO,  ROUTE_QR /*ROUTE_LOTES_FINALIZADOS*/} from '@/constants/ROUTES';

import CardAutoComplete from '@/components/core/card-auto-complete/Index.vue'
import CoreDateTimePickerField from '@/components/core/variant/date-time-picker-field variant/Index.vue'
import BtnAutoComplete from '@/components/core/btn-auto-complete_v2/Index.vue'
//import AppCardSecadorLote from '@/components/app/card/secadorlote/Index.vue'

import { OPLOCAL_STORAGE } from '@/constants/STORAGE'

// import { OPLOCAL_STORAGE, CADPRODUCAO_STORAGE } from '@/constants/STORAGE';

import db from '@/plugins/dexie';

import moment from 'moment-timezone';

function getSessionStorage(key, defaultValue) {
  return sessionStorage.getItem(key) ?? defaultValue;
}


// import AppCardAtividadeSkeleton from '../../components/app/card/atividade/Skeleton.vue';
import errorHandler from '@/utils/error-handler';
import geraData from '@/utils/geradata';


export default {
  name: 'DialogSecador',

  components: {
    CardAutoComplete,
    CoreDateTimePickerField,
    BtnAutoComplete,
    //AppCardSecadorLote
  },
  props: {
    idsecador: {
      type: Number,
      default: null
    },
    identificar: {
      type: Boolean,
      default: false
    },
    lotes: {type: Array},
    abastecer: {
      type: Boolean,
      default: false
    },
    abaoperacao: {type: String},
    abacard: {type: Object},
    op: {
      type: Boolean,
      default: false,
    },
    operacaoEstado: {
      type: String,
      default: ''
    },
    loa: {
      type: Boolean,
      default: false,
    },
    qr: {type: Object},
    numeroamostras:{ type: Number }
  },
  data() {
    return {
      rotaFiltros: [
        ROUTE_PRODUCAO_CADASTRO,
      ],
      fabrica: null,
      loading: true,
      lotesdaop: null,
      lotesfechados: null,
      proximolote: null,
      proximoembalagem: null,
      idordemproducao: null,
      lotecompleto: null,
      qrcode: {
        idaberturalote: null,
        lotecompleto: null,
      },
      abastecimento: {
        idaberturalote:null,
        inicio: geraData(),
        termino: "",
      },
      operacao: {
        inicio: geraData(),
        termino: null,
        peso: null,
        operacao: null,
        umidade: null,
        umidadear: null,
        temperaturaar: null,
      },
      formulario: {
        secsecador: null,
        secdatainicio: geraData(),
        secdataalteracao: null,
        secumidade: null,
        secidaberturalote: null,
        secstatus: null,
      },
      tipooperacao: [{
        text:'Pré-Limpeza',
        value:'Pré-Limpeza'
       },
       {
        text:'Secagem',
        value:'Secagem'
       }
      ],

      localarmazenamento: null,
      formArmazenamento: {
        local: null,
        data: geraData()
      },

      rules: {
        opetipo: [v => !!v || 'Tipo de secagem não pode estar vazio'],
        opeumidade: [v => !!v || 'Umidade não pode estar vazia'],
        opeinicio: [
          v => !!v || 'Data da operação não pode ser vazia', 
          v => {
            v // só pra ignorar o erro
            if (this.operacao.inicio > geraData()) {
              return 'Data da operação não pode ser maior que a atual'
            }
          },
        ],
        abslote: [ v => !!v  || 'Lote não pode estar vazio' ],
        absinicio: [
          v => !!v || 'Data de inicio não pode ser vazia',
          v => {
            v
            const inicioSemSegundos = geraData(this.abastecimento.inicio, 'YYYY-MM-DD HH:mm');
            if (this.abastecimento.termino !== '' && inicioSemSegundos > this.abastecimento.termino
              ) {
              return 'Data de inicio não pode ser maior que a data de termino'
            }
          }
        ],
        abstermino: [
          v => {
              // console.log('datasV',v, geraData(this.abastecimento.inicio,'YYYY-MM-DD HH:mm'))
              if (v && v < geraData(this.abastecimento.inicio,'YYYY-MM-DD HH:mm')) {
                return 'Data de termino não pode ser menor que a data de inicio'
              } 
          }
        ],
        armlocal: [v => !!v || 'Armazenamento não pode ser vazio.'],
        armdata: [
          v => !!v || 'Data do armazenamento não pode ser vazio', 
          v => {
            v // só pra ignorar o erro
            if (this.operacao.inicio > geraData()) {
              return 'Data do armazenamento não pode ser maior que a atual'
            }
          },
        ]
      },
      semvalor: false,
      reajusteScroll: null,

      itensComEsseNro: null,
      lotesMaisRecentes: [],
      abrirdialog: false,
      uaaa: false,
      secadorAnterior: null,
      w_peso: null,
    };
  },

  computed: {
    $_isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },
    $$idaberturalote() {
      return this.qrcode.idaberturalote;
    },
    $$operacaoEstado() {
      return this.$props.operacaoEstado;
    },
    $$secador() {
      return this.$props.idsecador;
    },
    $$lotes() {
      console.log('lotes',this.$props.lotes)
      return this.$props.lotes;
    },
    $$abastecimento() {
      return this.$props.abaoperacao;
    },
    $$abatermino() {
      return this.abastecimento.termino;
    },
    $$abacard() {
      console.log('tprops', this.$props.abacard)
      return this.$props.abacard;
    },
    $$formArmazenamento(){
      return this.formArmazenamento;
    },
    $$abastecer(){
      return this.$props.abastecer
    }
  },

  methods: {
    async $_setup() {
      this.lotesdaop = await db.aberturalote.orderBy('ablnrocontrole').filter((a) => !a.ablsecagem).toArray();
      this.localarmazenamento = await db.localarmazenamento.orderBy('loadescricao').toArray();

      const formulario = sessionStorage.getItem('formulario', null);
      if (formulario) {
        this.formulario = JSON.parse(formulario);
        sessionStorage.removeItem('formulario');
      }
    },

    async $_enviarLote() {
      console.log('qrcodelote', this.lotecompleto)
      this.qrcode.idaberturalote = null;
      this.$emit('update', {
        tipo: 'lote',
        secid: this.$props.idsecador,
        nro: this.lotecompleto.ablnrocontrole,
        id: this.lotecompleto.ablidaberturalote,
        });
      this.lotecompleto = null;
    },

    async $_enviarAbastecimento() {
      if(!this.$refs.formAbastecimento.validate()) {
        errorHandler('Abastecimento inválido.')
        return;
      }
      console.log('abastecimento', this.abastecimento, this.$props.idsecador)
      this.abastecimento.idaberturalote = this.qrcode.idaberturalote
      if(this.$props.abaoperacao) {
        this.abastecimento.operacao = this.$props.abaoperacao
      }
      for (const [index, value] of Object.entries(this.abastecimento)) {
        if(value === null || value === '') {
          delete this.abastecimento[index]
        }
      }
      this.$emit('update', {
        tipo: 'abastecimento',
        secid: this.$props.idsecador,
        ...this.abastecimento,
        })
    },

    async $_enviarOperacao() {
      if(!this.$refs.formOperacao.validate()) {
        errorHandler('Operação inválida.')
        return;
      }
      for (const [index, value] of Object.entries(this.operacao)) {
        if(value === null || value === '') {
          delete this.operacao[index]
        }
      }
      console.log('operacaoindo',this.operacao)
      this.$emit('update', {
        tipo: 'operacao',
        secid: this.$props.idsecador,
        ...this.operacao,
        })
    },

    async $_enviarArmazenamento() {
      if(!this.$refs.formArmazenamento.validate()) {
        errorHandler('Armazenamento inválido.')
        return;
      }
      for (const [index, value] of Object.entries(this.formArmazenamento)) {
        if(value === null || value === '') {
          delete this.formArmazenamento[index]
        }
      }
      if(this.numeroamostras < 2) errorHandler('É necessário ter pelo menos 2 amostras para concluir a operação.')
      else {
        this.$emit('update', {
          tipo: 'armazenamento',
          secid: this.$props.idsecador,
          ...this.formArmazenamento,
        })
      }
    },

    async $_submit() {
      if (this.$refs.form.validate()) {
      try{
        this.formulario.secdatatermino = moment().add(12, 'hours').toISOString();
        this.formulario.secdataalteracao = moment().toISOString();
        // this.formulario.secdatainicio.setHours(this.formulario.secdatainicio.getHours() - 3);
        delete this.formulario.id
        console.log(this.formulario);
        let a;
          const updateSecador = await db.secagem.where({secsecador: this.formulario.secsecador}).first();
          if (updateSecador) {
            // talvez fazer um pop-up com informações da ultima secagem daquele secador para poder confirmar
            // a atualização
            a = await db.secagem.update(updateSecador.id, this.formulario)
          }else {
            a = await db.secagem.add(this.formulario)//await this.$refs.config.$_submit();
          }
          Object.keys(this.formulario).forEach(k => this.formulario[k] = null);
          if (a) {
            errorHandler('Enviado com sucesso!');
            sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
            Object.keys(this.formulario).forEach(k => this.formulario[k] = null);
            this.$refs.form.resetValidation()
          }
      } catch (e) {
          console.log(e, 'eeeee');
          if(e.code == 'ERR_NETWORK'){
            errorHandler('Erro de conexão');
          } else {
            errorHandler(e);
          }
      }
      } else {
        errorHandler('Formulario inválido, verifique os dados e envie novamente');
      }
    },

/*     $_somaPeso(nro) {
      const itensComEsseNro = this.lotes.filter((item) => {
        return item.applote === nro;
      })

      const soma = itensComEsseNro.reduce((acc, cur) => {
        return acc +  Number(cur.appquantidade);
      }, 0);
      return soma;
    }, */

/*     FormataData(date, formato) {
      // return moment(date, 'YYYY-MM-DD').format('DD/MM-HH:MM');
      return moment.tz(date, 'America/Sao_Paulo').local().format(formato);
    }, */

/*     proximoInput() {
      this.$refs.loteb.$children[0].focus();
    }, */

/*     $_openDetalhe(nro) {
      sessionStorage.setItem(OPLOCAL_STORAGE.nro, nro);
      this.$router.replace({ 
        ...this.$route,
        name: ROUTE_LOTES_FINALIZADOS.name,
      });
    }, */

    $_onClickQR() {
      sessionStorage.setItem('formulario', JSON.stringify({idsecador: this.$props.idsecador,...this.abastecimento}));
      setTimeout(() => {
        this.$router.push({
          ...this.$route,
          name: ROUTE_QR.name,
        });
      });
    },

    async $_verificaQR() {
      const qr = await getSessionStorage(OPLOCAL_STORAGE.qr, '');
      if (qr && qr.length && qr !== 'null') {
        const lote  = (await db.aberturalote.where({ ablnrocontrole: qr }).toArray());
        if (!lote.length) {
          errorHandler('Lote não encontrado');
          return;
        }
        this.qrcode.idaberturalote = lote[0].ablidaberturalote;
        this.lotecompleto = {...lote[0]}
        this.$refs.umidade.focus();
        if (typeof this.proximolote === 'object') {
          // this.$_adicionaLote(this.proximolote);
        } else {
          errorHandler('Erro ao adicionar novo lote')
        }
      }
      sessionStorage.setItem(OPLOCAL_STORAGE.qr, '');
      // this.proximolote = JSON.parse(sessionStorage.getItem('lote'));
      // this.proximoembalagem= JSON.parse(sessionStorage.getItem('loteembalagem'));
      // this.w_peso = sessionStorage.getItem('peso', this.w_peso);
    },

    async $_terminoResetaValor() {
      if (this.$$_terminoTemValor()) {
        // Mesmo depois do clique terminoTemValor ainda está voltando true;
        await this.$$_terminoTemValor().firstElementChild.click();
        this.semvalor = true;
        this.abastecimento.termino = ''
      } else {
        this.semvalor = false;
      }
    },

    $$_terminoTemValor() {   
      const input = this.$refs.datatermino.$el;
      const clearButton = input.querySelector('.v-input__icon.v-input__icon--clear');
      console.log(!!clearButton);
      return clearButton;
    },
  },

  created() {
    this.$_setup();
    this.$_verificaQR();
  },

  watch: {
     $$abacard: {
      deep: true,
      immediate:true,
      handler() {
        setImmediate(() =>  {
          this.qrcode.idaberturalote = this.abacard?.absidaberturalote;
        })
        this.abastecimento.inicio = this.abacard?.absdatainicio,
        this.abastecimento.termino = this.abacard?.absdatatermino ?? ''
        console.log('SSSSSSSSSSSSSSSSSSSSSSSS',this.abacard, this.abastecimento)
      }
    },
    $$secador: {
      immediate: true,
      handler() {
          console.log('asssd', this.idsecador ,this.secadorAnterior,this.idsecador == this.secadorAnterior)
            this.qrcode= {
              lotecompleto: null,
              idaberturalote: null,
            }
            this.formArmazenamento = {
              data: geraData(),
              local: null
            }
            this.lotecompleto = null,
            this.operacao = {
              inicio: geraData(),
              termino: null,
              peso: null,
              operacao: null,
              umidade: null,
              umidadear: null,
              temperaturaar: null,
            }
            if(!this.abacard) {
              this.abastecimento = {
                inicio: geraData(),
                termino: ''
              }
            }
            this.$refs.formAbastecimento.reset();
            this.$refs.formAbastecimento.resetValidation();
      }
    },
    $$abatermino: {
      immediate:true,
      deep: true,
      handler() {
        this.semvalor = true;
        if (this.abastecimento.termino === 'Invalid date') this.semvalor = false;
        else if (geraData(this.abastecimento.termino) !== 'Invalid date') this.semvalor = false;
      }
    },

  /*   $$formArmazenamento: {
      deep:true,
      immediate:true,
      handler() {
        console.log('armaz', this.formArmazenamento);
      }
    },
    $$abastecimento: {
      deep:true,
      immediate:true,
      handler() {
        console.log('abaop',this.$props.abaoperacao);
      }
    },
    // feito para limpar os campos do form
    $$lotes:{
      immediate: true,
      deep:true,
      handler() {
        console.log('watchlotes')
      }
    }, */
    $$operacaoEstado: {
    immediate: true,
    handler() {
      if(this.$props.operacaoEstado === 'operando') {
        this.operacao.termino = geraData()
      } else {
        this.operacao.termino = null;
      }
    }
    },
    qr: {
      immediate:true,
      handler(){
        this.abastecimento = {
          inicio: this.$props.qr.inicio,
          termino: this.$props.qr.termino,
        }
      }
    },
    $$idaberturalote: {
      immediate:true,
      deep:true,
      handler() {
          if (this.qrcode.idaberturalote) {
            this.lotecompleto = null;
            (db.aberturalote.where({ ablidaberturalote: this.qrcode.idaberturalote }).toArray()).then((item) => {
              console.log(item[0], 'aaa');
              (db.produto.where({ proidproduto: item[0].ablidproduto }).toArray()).then((itemProduto) => {
                console.log('itemproduto', itemProduto);
                if (itemProduto[0]?.proidvariedade) {
                (db.variedade.where({ varidvariedade: itemProduto[0].proidvariedade }).toArray()).then((itemVariedade) => {
                  this.lotecompleto = { ...item[0], ...itemVariedade[0] };
                });
                } else {
                  this.lotecompleto = { ...item[0] };
                }
              })
            }) 
          }
          this.$refs.formAbastecimento.resetValidation();
      }
    },

    proximolote() {
      sessionStorage.setItem('lote', JSON.stringify(this.proximolote));
    },

    proximoembalagem() {
      sessionStorage.setItem('loteembalagem', JSON.stringify(this.proximoembalagem));
    }
  }

  // watch: {
  //   proximolote(valor) {
  //     this.fabricalocal = (db.aberturalote.where({ fabidfabrica: valor.ablidfabrica  }).toArray())[0];
  //   }
  // }
};
</script>

<style scoped>
  .space {
    margin-bottom: 45px;
  }

  .center {
    width: 100%;
    text-align: center;
  }

  .card {
    padding: 3px;
    margin: 15px 10px 0px 10px
  }

  .card-secador {
    width: 90%;
    text-align: center;
    margin: 20px;
  }

  .linhas {
    height: 21%;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
  }

  .finalizado {
    background-color: #4CAF50;
  }

  .iniciado {
    background-color: #6b93ff;
  }

  .disponivel {
    background-color: #b9b9b9;
  }

  .digitavel {
    margin-bottom: 25px;
  }

    .linha-menor {
    height: 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 4px 0px 4px;
    font-size: 13px;
  }

  .inner-card {
    display: flex;
    justify-content: space-between;
    height: 67%;
  }

  .container-inner-items {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .container-inner-items-fill {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

  .card-btn {
    transform: translateY(10px);
  }

  .txt-center {
    text-align: center;
  }

  .input-container {
      width: 60%;
  }

  .container {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .contaainer {
    width: 93vw;
    max-width: 300px;
    flex-wrap: wrap;
  }

  .textfield {
    width: 90%;
  }

  .n-center >>> input {
      text-align: center;
  }

  .n-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .nn-center >>> input {
      text-align: center;
  }

  .nn-center >>> input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  .descricaoextra {
    color: #3d68de;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin-bottom: 20px;
    padding: 5px;
    background-color: #fdffd2;
  }

  .centerextra {
      flex: 1;
      text-align: center;
      font-size: 14px;
      font-weight: 500;
  }
  .card-lote-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-inline: auto;
    max-width: 450px;
  }
  .card-lote {
    width: 100%;
  }

body.keyboard {
    height: calc(100% + 500px); /* add padding for keyboard */
}
  
</style>
